import apiClient from '@/services/api/apiClient';
import { buildApiUrl } from '../utils';
import { GetTeamCompetitionResponse, PostTeamCompetitionResponse } from '../response/competition';

export class CompetitionService {
  static getCompetitions() {
    return apiClient.get<any>(buildApiUrl('/api/v1/team/competition'), undefined);
  }

  static getCompetitionById(id: string) {
    return apiClient.get<GetTeamCompetitionResponse>(buildApiUrl('/api/v1/team/competition/:id', { id }), undefined);
  }

  static postCompetition(data: any) {
    return apiClient.post<PostTeamCompetitionResponse>(buildApiUrl('/api/v1/team/competition'), data);
  }

  static putCompetition(id: string, data: any) {
    return apiClient.update<PostTeamCompetitionResponse>(buildApiUrl('/api/v1/team/competition/:id', { id }), data);
  }

  static deleteCompetition(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/team/competition/:id', { id }));
  }
}
